<template>
  <Modal name="bouwvak">
    <div :class="$style.wrapper">
      <div :class="$style.header">
        <i data-i="warning" :class="$style.icon" />
        <strong>{{ $t('order-delivery:bouwvakModal.title') }}</strong>
      </div>
      <p>{{ $t('order-delivery:bouwvakModal.body') }}</p>
      <p>
        <strong>{{ $t('order-delivery:bouwvakModal.regionTitle') }}</strong>
      </p>
      <span :class="$style.dateBadge">
        {{ $t('order-delivery:bouwvakModal.dateRange') }}
      </span>
    </div>
    <div v-if="modal.context?.onConfirm" :class="$style.actions" class="mt-4">
      <CButton :class="$style.closeButton" @click="onConfirm">
        {{ $t('order-delivery:bouwvakModal.setReadyCta') }}
      </CButton>
      <CButton color="borderless" @click="modal.close('bouwvak')">
        {{ $t('common:buttons.cancel') }}
      </CButton>
    </div>
    <CButton
      v-else
      :class="$style.closeButton"
      class="mt-4"
      @click="modal.close('bouwvak')"
    >
      {{ $t('common:actions.close') }}
    </CButton>
  </Modal>
</template>

<script setup lang="ts">
import { useModal } from '@/composables/plugins';

const modal = useModal<{ onConfirm?: () => void }>();

function onConfirm() {
  modal.context?.onConfirm?.();
  modal.close('bouwvak');
}
</script>

<style module>
.wrapper {
  border-left: 4px solid var(--amber-600);
  padding-left: 1.25rem;
}

.header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 1.1rem;
}

.icon {
  color: var(--amber-600);
  flex-shrink: 0;
}

.dateBadge {
  display: inline-block;
  border: 1px solid var(--amber-600);
  border-radius: 4px;
  padding: 0.25rem 0.75rem;
  color: var(--amber-600);
  font-weight: 600;
  margin-top: 0.75rem;
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.closeButton {
  background-color: var(--amber-600) !important;
  color: var(--color-white) !important;
}
</style>
